import React, { Component } from 'react';
import { Error } from '@material-ui/icons';
import InputAdornment from '@material-ui/core/InputAdornment';

export class InputErrorIcon extends Component {
  render() {
    return <InputAdornment position="end"><Error color="error" /></InputAdornment>;
  }
}
